import { DIFFICULTY_COLORS, TOTAL_PROBLEMS } from './constants.js';
import { dom } from './dom.js';
import { getMaxScoreForLevel } from './scoring.js';
import { state } from './state.js';

const FILL_CLASS_NAMES = [
    'level-btn--fill-light',
    'level-btn--fill-dark',
    'level-btn--fill-bright',
];

function getLevelFillPercent(level) {
    const score = state.scoresByLevel[level];
    if (score === undefined || score <= 0) return 0;
    return (score / getMaxScoreForLevel(level)) * 100;
}

function hasMaxScore(level) {
    const score = state.scoresByLevel[level];
    return score !== undefined && score >= getMaxScoreForLevel(level);
}

export function initLevelButtons(onSelectLevel) {
    dom.levelButtonsContainer.innerHTML = '';
    dom.levelButtons = [];

    for (let level = 1; level <= TOTAL_PROBLEMS; level++) {
        const item = document.createElement('div');
        item.className = 'level-item';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'level-btn';
        btn.textContent = String(level);
        btn.dataset.level = String(level);
        btn.setAttribute('aria-label', `Level ${level}`);
        btn.addEventListener('click', () => onSelectLevel(level));

        const scoreEl = document.createElement('span');
        scoreEl.className = 'level-score';
        scoreEl.setAttribute('aria-hidden', 'true');

        item.appendChild(btn);
        item.appendChild(scoreEl);
        dom.levelButtonsContainer.appendChild(item);
        dom.levelButtons.push({ item, btn, scoreEl });
    }
}

export function updateLevelButtons({ animateCurrentFill = false } = {}) {
    dom.levelButtons.forEach(({ item, btn, scoreEl }, index) => {
        const level = index + 1;
        const color = DIFFICULTY_COLORS[level - 1];
        const fillPercent = getLevelFillPercent(level);
        const isCurrent = level === state.currentProblem;
        const isPassed = state.submittedLevels.has(level) || state.passedLevels.has(level);
        const bestScore = state.scoresByLevel[level];
        btn.disabled = state.gameMode === 'daily' || state.gameMode === 'time';

        item.classList.toggle('level-item--current', isCurrent);

        btn.classList.remove(
            'level-btn--current',
            'level-btn--passed',
            'level-btn--idle',
            ...FILL_CLASS_NAMES,
        );
        btn.style.borderColor = '';
        btn.style.color = '';
        btn.style.backgroundColor = '';
        btn.style.backgroundImage = '';
        btn.style.textShadow = '';
        btn.style.setProperty('--level-fill', '0%');

        if (bestScore !== undefined) {
            scoreEl.textContent = String(bestScore);
            scoreEl.classList.toggle('level-score--positive', bestScore > 0);
            scoreEl.classList.toggle('level-score--zero', bestScore === 0);
            scoreEl.hidden = false;
        } else {
            scoreEl.textContent = '';
            scoreEl.hidden = true;
        }

        if (isCurrent) {
            btn.classList.add('level-btn--current');
            btn.setAttribute('aria-current', 'step');
            btn.style.borderColor = color;
            if (fillPercent > 0) {
                btn.classList.add('level-btn--fill-light');
            } else {
                btn.style.backgroundColor = '#ffffff';
            }
        } else if (isPassed) {
            btn.classList.add('level-btn--passed');
            btn.setAttribute('aria-current', 'false');
            btn.style.borderColor = color;
            if (fillPercent > 0) {
                btn.classList.add(hasMaxScore(level) ? 'level-btn--fill-bright' : 'level-btn--fill-dark');
            } else {
                btn.style.color = '#d1d5db';
            }
        } else {
            btn.classList.add('level-btn--idle');
            btn.setAttribute('aria-current', 'false');
        }

        const shouldAnimate = animateCurrentFill && isCurrent && fillPercent > 0;
        if (shouldAnimate) {
            requestAnimationFrame(() => {
                btn.style.setProperty('--level-fill', `${fillPercent}%`);
            });
        } else {
            btn.style.setProperty('--level-fill', `${fillPercent}%`);
        }
    });
}
